/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Gotolearnmode3Inputs */

const zh_share_gotolearnmode3 = /** @type {(inputs: Share_Gotolearnmode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往学习模式`)
};

const en_share_gotolearnmode3 = /** @type {(inputs: Share_Gotolearnmode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Study Mode`)
};

/** @type {(inputs: Share_Gotolearnmode3Inputs) => LocalizedString} */
const es_share_gotolearnmode3 = zh_share_gotolearnmode3;

/**
* | output |
* | --- |
* | "Go to Study Mode" |
*
* @param {Share_Gotolearnmode3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_gotolearnmode3 = /** @type {((inputs?: Share_Gotolearnmode3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Gotolearnmode3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_gotolearnmode3(inputs)
	if (locale === "en") return en_share_gotolearnmode3(inputs)
	return es_share_gotolearnmode3(inputs)
});
export { share_gotolearnmode3 as "share_goToLearnMode" }